import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { UserRole } from '@/mocks/ai-logic';

interface DiscussionsContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  role: UserRole;
  setRole: (role: UserRole) => void;
  managerName: string;
  setManagerName: (name: string) => void;
}

const DiscussionsContext = createContext<DiscussionsContextType | null>(null);

export function DiscussionsProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState<UserRole>('director');
  const [managerName, setManagerName] = useState('Иванов А.С.');

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(v => !v), []);

  return (
    <DiscussionsContext.Provider value={{ isOpen, open, close, toggle, role, setRole, managerName, setManagerName }}>
      {children}
    </DiscussionsContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useDiscussions() {
  const ctx = useContext(DiscussionsContext);
  if (!ctx) throw new Error('useDiscussions must be used within DiscussionsProvider');
  return ctx;
}